module.exports = __webpack_public_path__ + "img/arrowhead.5c1c03b1.png";